import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import BackToTop from '@/components/base/BackToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import TopRanking from './components/TopRanking';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <LatestUpdates />
        <TopRanking />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}